// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { QuickWinSelectedAnswerRequest } from "../schema";

export function serialize_QuickWinSelectedAnswerRequest_internal(value: QuickWinSelectedAnswerRequest): unknown {
  return ((value: { selectedAnswerIndex: number }): unknown => {
    return {
      selectedAnswerIndex: ((value: number): unknown => {
        return value;
      })(value["selectedAnswerIndex"]),
    };
  })(value);
}
export function serialize_QuickWinSelectedAnswerRequest(obj: QuickWinSelectedAnswerRequest): string {
  return renderJsonWithNumbersAsBigint(serialize_QuickWinSelectedAnswerRequest_internal(obj));
}
export function deserialize_QuickWinSelectedAnswerRequest_internal(value: unknown): ParserResult<QuickWinSelectedAnswerRequest> {
  return ((
    value: unknown,
  ): ParserResult<{
    selectedAnswerIndex: number;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/QuickWinSelectedAnswerRequest]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/QuickWinSelectedAnswerRequest]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "selectedAnswerIndex")) {
      return { success: false, reason: `[#/components/schemas/QuickWinSelectedAnswerRequest/selectedAnswerIndex]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'selectedAnswerIndex'.` };
    }
    const parsed_selectedAnswerIndex = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/QuickWinSelectedAnswerRequest/selectedAnswerIndex]: '${value}' expected to be of type number.` };
      })(value["selectedAnswerIndex"]);
    })();
    if (!parsed_selectedAnswerIndex.success) {
      return { success: false, reason: parsed_selectedAnswerIndex.reason };
    }
    return { success: true, value: { selectedAnswerIndex: parsed_selectedAnswerIndex.value } };
  })(value);
}
export function deserialize_QuickWinSelectedAnswerRequest(str: string): ParserResult<QuickWinSelectedAnswerRequest> {
  return deserialize_QuickWinSelectedAnswerRequest_internal(parseJsonWithNumbersAsBigint(str));
}
